import React from 'react';

class EventList extends React.Component {
  render() {

    const styles = {
      eventHolder: {
        border: '1px #cccccc solid',
        padding: '10'
      },
      event: {
        marginBottom:'10'
      },
      textButton: {
        border: 0,
        fontSize: 16,
        fontWeight: '600',
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 56,
        textTransform: 'capitalize',
      }
    }
    if (this.props.events) {
      try {
        const events = this.props.events.map((event) =>
          <div style={ styles.event }>
            <div>{event.eventName}</div>
            <div style={styles.eventHolder} dangerouslySetInnerHTML={{ __html: event.eventDescription }}></div>
          </div>
      );

      return (
      <ul className={'contentField-container'}>
        {events}
      </ul>
      );
      } catch (ex) {
        return (<div></div>);
      }

    } else {
      return (
        <div></div>
      )
    }

  }
}

export default EventList;



// WEBPACK FOOTER //
// ./src/components/EventList.js